export default defineAppConfig({
  ui: {
    colors: {
      primary: 'blue', // 林超：主题色
      neutral: 'slate',
      important: 'violet'
    }
  },
  uiPro: {
    pageHero: {
      slots: {
        container: 'py-10 sm:py-20 lg:py-20',
        title: 'sm:text-5xl'
      }
    },
    prose: {
      img: {
        base: 'w-full'
      },
      codeTree: {
        slots: {
          root: 'bg-default m-0',
          content: '[&>div>pre]:rounded-r-none'
        }
      }
    }
  }
})
